import { OrderCard } from 'components/LightConversation/components/OrderCard';
import { useRef } from 'react';
import { useMemoizedFn } from 'ahooks';

interface TradeListProps {
  conversation: Conversation.Conversation;
  tradeList: Conversation.Trade.Vo[];
}

export const LightTradeList = (props: TradeListProps) => {
  const { conversation, tradeList } = props;
  const containerRef = useRef<HTMLDivElement>(null);

  const handleScrollToOrder = useMemoizedFn((externalTradeId: string) => {
    const container = containerRef.current;
    if (container) {
      const targetEl = container.querySelector(
        `[data-external-trade-id="${externalTradeId}"]`,
      ) as HTMLElement | null;
      if (targetEl) {
        targetEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  });

  return (
    <div className="flex-1 flex flex-col overflow-y-auto pb-3 gap-3 relative" ref={containerRef}>
      {tradeList.map((order) => (
        <div key={order.internalTradeId} data-external-trade-id={order.externalTradeId}>
          <OrderCard
            sendable={false}
            conversation={conversation}
            order={order}
            onScrollToOrder={handleScrollToOrder}
          />
        </div>
      ))}
    </div>
  );
};
